module.exports = __webpack_public_path__ + "static/media/uploadFiles.daae9c55.svg";